import {
  fetchTableCoversByFilterThunk,
  selectTableCoversMetaState,
  type TableCoversFilterKey,
} from '@/redux/slices/tableCoverSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { BaseFileEnum } from '@/typings/domain'
import { useFocusEffect } from 'expo-router'
import { useCallback } from 'react'
import TableCoverList from './TableCoverList'

type Props = {
  activeFilter: TableCoversFilterKey
  ListHeaderComponent?: React.ReactElement
}

export default function TableCoversByFilter({ activeFilter, ListHeaderComponent }: Props) {
  const dispatch = useAppDispatch()

  const tableCoversLoaded = useAppSelector(
    state => selectTableCoversMetaState(state, { filter: activeFilter }, BaseFileEnum.Form).loaded
  )
  const folderCoversLoaded = useAppSelector(
    state => selectTableCoversMetaState(state, { filter: activeFilter }, BaseFileEnum.FormFolder).loaded
  )

  const refetchCovers = useCallback(() => {
    dispatch(fetchTableCoversByFilterThunk({ filter: activeFilter, type: BaseFileEnum.FormFolder, reset: true }))
    dispatch(fetchTableCoversByFilterThunk({ filter: activeFilter, type: BaseFileEnum.Form, reset: true }))
  }, [activeFilter, dispatch])

  useFocusEffect(refetchCovers)

  const handleLoadMore = useCallback(
    (type: BaseFileEnum) => {
      dispatch(fetchTableCoversByFilterThunk({ filter: activeFilter, type }))
    },
    [activeFilter, dispatch]
  )

  const initialLoading = !folderCoversLoaded && !tableCoversLoaded

  return (
    <TableCoverList
      filter={activeFilter}
      includeFolder
      onLoadMore={handleLoadMore}
      onRefresh={refetchCovers}
      ListHeaderComponent={ListHeaderComponent}
      initialLoading={initialLoading}
    />
  )
}
